export const RESEARCH_TEAM = {
    EFFORT_FORMAT: {
        PERCENTAGE: "percentage",
        MONTHS: "months",
    },
    ASSOCIATION_TYPE: {
        INTERNAL: "internal",
        EXTERNAL: "external",
    },
};